// extracted by mini-css-extract-plugin
export default {"container":"r0-z","list":"s0-z"};